import { z } from 'zod';

export const ActionTypeScalarFieldEnumSchema = z.enum(['actiontypeId','cityId','actionName','displayOrder','isInspection','popupTemplate']);

export default ActionTypeScalarFieldEnumSchema;
